import { render, staticRenderFns } from "./ModalOrderProcessShabu.vue?vue&type=template&id=409b962d&"
import script from "./ModalOrderProcessShabu.vue?vue&type=script&lang=js&"
export * from "./ModalOrderProcessShabu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports